import {Routes} from '@angular/router';
import {PageNotFoundComponent} from "./component/page-not-found/page-not-found.component";
import {provideState} from "@ngrx/store";
import {provideEffects} from "@ngrx/effects";
import {article} from "./blog/ng-store/reducer/article.reducer";
import {ArticleEffect} from "./blog/ng-store/effect/article.effect";
import {reducer} from "./contact/ng-store/reducer/contact.reducer";
import {ContactEffect} from "./contact/ng-store/effect/contact.effect";
import {unsubscribe} from "./unsubscribe/ng-store/reducer/unsubscribe.reducer";
import {UnsubscribeEffect} from "./unsubscribe/ng-store/effect/unsubscribe.effect.service";
import {BlogEffect} from "./section-blog/ng-store/effect/blog.effect";
import {blog} from "./section-blog/ng-store/reducer/blog.reducer";
import {importProvidersFrom} from "@angular/core";
import {BlogService} from "./blog/ng-store/service/blog.service";
import {BlogService as SectionBlogService} from "./section-blog/ng-store/service/blog.service";
import {ContactService} from "./contact/ng-store/service/contact.service";

export const routes: Routes = [
  {path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule)},
  {path: 'about', loadChildren: () => import('./about/about.module').then(m => m.AboutModule)},
  {path: 'services', loadChildren: () => import('./services/services.module').then(m => m.ServicesModule)},
  {path: 'portfolio', loadChildren: () => import('./portfolio/portfolio.module').then(m => m.PortfolioModule)},
  {
    path: 'blog',
    loadChildren: () => import('./blog/blog-routing.module').then(m => m.routes),
    providers: [
      provideState({name: 'article', reducer: article}),
      provideState({name: 'blog', reducer: blog}),
      provideEffects([ArticleEffect, BlogEffect]),
      BlogService,
      SectionBlogService
    ]
  },
  {
    path: 'contact',
    loadChildren: () => import('./contact/contact-routing.module').then(m => m.routes),
    providers: [
      provideState({name: 'contact', reducer: reducer}),
      provideEffects([ContactEffect]),
      ContactService
    ]
  },
  {path: 'policy', loadChildren: () => import('./policy/policy.module').then(m => m.PolicyModule)},
  {path: 'terms', loadChildren: () => import('./terms/terms.module').then(m => m.TermsModule)},
  {
    path: 'unsubscribe',
    loadChildren: () => import('./unsubscribe/unsubscribe.module').then(m => m.UnsubscribeModule),
    providers: [
      provideState({name: 'unsubscribe', reducer: unsubscribe}),
      provideEffects([UnsubscribeEffect])
    ]
  },
  {path: '', redirectTo: '/home', pathMatch: 'full'},
  {path: '**', title: 'page not found', component: PageNotFoundComponent}
];
